import { Component } from '@angular/core';

@Component({
  selector: 'boma-phone-number-input',
  templateUrl: './phone-number-input.component.html',
  styleUrls: ['./phone-number-input.component.css'],
})
export class PhoneNumberInputComponent {}
